import { render, staticRenderFns } from "./ModalTaxes.vue?vue&type=template&id=590f59fd"
import script from "./ModalTaxes.vue?vue&type=script&lang=js"
export * from "./ModalTaxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports